var Bavaria = "바이에른";
var Berlin = "베를린";
var Brandenburg = "브란덴부르크";
var Bremen = "브레멘";
var Hamburg = "함부르크";
var Hesse = "헤센";
var Saarland = "자를란트";
var Saxony = "작센";
var Thuringia = "튀링겐";
var DEStates = {
	"Baden-Wuerttemberg": "바덴뷔르템베르크",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "메클렌부르크포어포메른",
	"Lower Saxony": "니더작센",
	"North Rhine-Westphalia": "노르트라인베스트팔렌",
	"Rhineland-Palatinate": "라인란트팔츠",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "작센안할트",
	"Schleswig-Holstein": "슐레스비히 홀슈타인",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
